import React from "react";

const Banner = () => {
    return (
        <div>
            <div className="container-fluid"> 
                <div className="imagenFondo p-4">
                    <h1 className="tituloBanner">CONSULTORIO PSICOLÓGICO</h1>
                    <h5 className="tituloBanner">Iniciá tu camino hacia una autotransformación</h5>
                    <h3 className="textoBanner">Empezá terapia 
</h3>    
                    <div className="text-center p-4">
                        <a className="fs-6 fw-bold"href="https://walink.co/966361" ><button className="botonBanner p-2 fw-bold">HACÉ TU CONSULTA</button></a>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    )    
}

export default Banner;